import React, { Component } from 'react';
import { Layout, Cascader, Drawer, Form, Breadcrumb, Input, Select, DatePicker, 
    Button, TreeSelect, Table, Divider, Pagination, Modal,Popconfirm,message } from 'antd';
import moment from 'moment';
import Subside from '../../page/Home/Subside';
// import request from '../../api/request';
import subapi from '../subapi';
import './index.css';
// import api from '../../api/api';
import EditVersion from './EditVersion';
const { Content } = Layout;
const FormItem = Form.Item;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class EditionManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {
                page: 1,
                page_size: 10,
                pageSizeChange: this.pageChange,
                pageSizeOptions: ['10', '20', '100']
            },
            publishing: [], //发版平台
            dataList: [], //发版管理列表
            total: []
        }
    }
    componentDidMount() {
        this.request()
        this.managementList()
    }
    pageChange = (page, page_size) => {
        this.setState(
            Object.assign({}, this.state, {
                options: Object.assign({}, this.state.options, {
                    page: page,
                    page_size: page_size,
                }),
            }),
        );
    };

    //获取发版平台
    request = () => {
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        let params = {
            access_token: token,
        };
        subapi.appList(params).then(res => {
            if(res.code === 0){
                this.setState({ publishing: res.content })
            }
        })
    }
    //获取发版管理列表
    managementList = () => {
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        let params = {
            access_token: token,
            page: this.state.options.page,
            page_size: this.state.options.page_size
        };
        subapi.managementList(params).then(res => {
            //console.log(res)
            this.setState({ dataList: res.content.data, total: res.content })
        })

    }
    formatTen(num) {
        return num > 9 ? (num + "") : ("0" + num);
    }

    formatDate = (date) => {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    }

    //查询
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values)
            // let type = '';
            // let app = '';
            let start_time = '';
            let end_time = '';
            // if (values.type) {
            //     values.type.map(item => {
            //         if (item === '彩管家') {
            //             app = 'cgj'
            //         } else if (item === 'Android') {
            //             type = '1'
            //         } else if (item === '彩之云') {
            //             app = 'czy'
            //         } else if (item === 'ios') {
            //             type = '2'
            //         }
            //     })
            // }
            if (values.Date && values.Date.length > 0) {
                start_time = this.formatDate(new Date(values.Date[0]._d));
                end_time = this.formatDate(new Date(values.Date[1]._d));
            }
            if (!err) {
                let param = {}
                if (start_time && end_time) {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: 1,
                        page_size: this.state.options.page_size,
                        start_time: start_time,
                        end_time: end_time,
                    };
                } else {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: 1,
                        page_size: this.state.options.page_size,
                    };
                }

                for (let item in values) {
                    if (values[item]) {
                        switch (item) {
                            case 'version':
                                param['version'] = values[item];
                                break;
                            case 'release':
                                param['app'] = values[item] === '彩管家' ? 'cgj' :values[item]==='彩之云'? 'czy':'wyt';
                                break;
                            case 'type':
                                param['type'] = values[item] === 'ios' ? '2' : '1';
                                break;
                        }
                    }
                }
                subapi.managementList(param).then(res => {
                    this.setState({ dataList: res.content.data, total: res.content })
                })
                this.pageChange(1, this.state.options.page_size);
            }
        })
    }
    pagingList = (temp) => {
        console.log(temp)
        this.props.form.validateFields((err, values) => {

            let start_time = '';
            let end_time = '';
            if (values.Date && values.Date.length > 0) {
                start_time = this.formatDate(new Date(values.Date[0]._d))
                end_time = this.formatDate(new Date(values.Date[1]._d))
            }

            if (!err) {
                let param = {}
                if (start_time && end_time) {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: temp.page,
                        page_size: temp.page_size,
                        start_time: start_time,
                        end_time: end_time,
                    };
                } else {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: temp.page,
                        page_size: temp.page_size,
                    };
                }
                for (let item in values) {
                    if (values[item]) {
                        switch (item) {
                            case 'version':
                                param['version'] = values[item];
                                break;
                            case 'release':
                                param['app'] = values[item] === '彩管家' ? 'cgj' :values[item]==='彩之云'? 'czy':'wyt';
                                break;
                            case 'type':
                                param['type'] = values[item] === 'ios' ? '2' : '1';
                                break;
                        }
                    }
                }
                subapi.managementList(param).then(res => {
                    this.setState({ dataList: res.content.data, total: res.content })
                })
            }
        })
    }
    //添加发版管理
    addTo = () => {
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        this.props.history.push(`/EditionManagement/AddedReleaseManagement?access_token=${token}`);
    }
    release = (data) => {
        let publish = [];
      if(data){
        data.map((item, index) => {
            publish.push({
                key: index,
                value: item.name,
                title: item.name,
            })
        })
      }
        return publish;
    }
    //查看详情
    examine = (orderNum) => {
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        this.props.history.push(`/EditionManagement/releaseDetails/${orderNum}?access_token=${token}`);
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        let treeData = this.release(this.state.publishing)
        const options = [
            {
                key: '1',
                value: 'Android',
                title: 'Android',
            },
            {
                key: '2',
                value: 'ios',
                title: 'ios',
            },
        ];

        return (
            <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                <Layout style={{ height: '100%' }}>
                    <div style={{ display: 'flex' }}>
                        <Content style={{ backgroundColor: 'rgb(242, 244, 245)', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>

                                <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                                    <div style={{ padding: '14px 16px', borderBottom: '1px solid rgb(204, 204, 204)', background: "#fff" }}>
                                        <Breadcrumb>
                                            <Breadcrumb.Item>发版管理</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>
                                    <Layout id="project_management">
                                        <Content className="content">
                                            <div>
                                                <Form
                                                    style={{
                                                        display: 'flex',
                                                        padding: '0 0rem 1rem 1rem',
                                                        position: 'relative',
                                                        borderBottom: '1px solid #ccc'
                                                    }}
                                                    layout="inline"
                                                    onSubmit={this.handleSubmit}>
                                                    <FormItem label="版本号">
                                                        {getFieldDecorator('version')(
                                                            <Input
                                                                onPressEnter={this.handleSubmit}
                                                                placeholder="请输入版本号"
                                                                type="text"
                                                                style={{ width: 150 }}
                                                                allowClear
                                                            />,
                                                        )}
                                                    </FormItem>
                                                    <FormItem label="App类型">
                                                        {getFieldDecorator('type')(
                                                            <TreeSelect
                                                                style={{ width: 120 }}
                                                                // value={this.props.match.params.action === 'edit' ? parseInt(commodityList.cat_pid) !== 0?commodityList.cat_pid:'' : ''}
                                                                treeData={options}
                                                                placeholder="请选择"
                                                                allowClear
                                                            />
                                                        )}
                                                    </FormItem>
                                                    <FormItem label="发版平台">
                                                        {getFieldDecorator('release')(
                                                            <TreeSelect
                                                                style={{ width: 120 }}
                                                                // value={this.props.match.params.action === 'edit' ? parseInt(commodityList.cat_pid) !== 0?commodityList.cat_pid:'' : ''}
                                                                treeData={treeData}
                                                                placeholder="请选择"
                                                                onChange={this.handleChange}
                                                                allowClear
                                                            />,
                                                        )}
                                                    </FormItem>
                                                    {/* <FormItem label="发版时间">
                                                        {getFieldDecorator('startDate')(
                                                            <DatePicker
                                                                locale={zhCN}
                                                                placeholder="选择开始时间"
                                                                format="YYYY-MM-DD HH:mm:ss"
                                                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                                style={{ width: 10 }}
                                                                onPanelChange={this.handleSubmit}
                                                            />,
                                                        )}
                                                        <span style={{ margin: 2 }}>-</span>
                                                        {getFieldDecorator('endDate')(
                                                            <DatePicker
                                                                locale={zhCN}
                                                                placeholder="选择结束时间"
                                                                format="YYYY-MM-DD HH:mm:ss"
                                                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                                style={{ width: 10 }}
                                                                onPanelChange={this.handleSubmit}
                                                            />,
                                                        )}
                                                    </FormItem> */}
                                                    <FormItem label="发版时间">
                                                        {getFieldDecorator('Date')(
                                                            <RangePicker />)}
                                                    </FormItem>


                                                </Form>
                                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '20px' }}>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        style={{ marginRight: '1rem' }}
                                                        onClick={this.handleSubmit}
                                                    >
                                                        查询
                                                    </Button>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        style={{ marginRight: '1rem' }}
                                                        onClick={this.addTo}
                                                    >
                                                        添加
                                                    </Button>
                                                </div>
                                            </div>
                                            <CustomTable
                                                examine={this.examine}
                                                dataList={this.state.dataList}
                                                options={this.state.options}
                                                total={this.state.total}
                                                pagingList={this.pagingList}
                                                managementList={this.managementList}
                                            ></CustomTable>
                                        </Content>
                                    </Layout>
                                </div>
                            </div>
                        </Content>
                    </div>
                </Layout>
            </div>
        );
    }
}

const OrderEditionManagement = Form.create()(EditionManagement);
export default OrderEditionManagement;



class CustomTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editorialContent: "",
            id:"",
            visible:false,
            //grayScaleRange:"", //灰度范围判断
        }
    }
    componentDidMount(){
        // console.log(this.state.grayScaleRange)
    }
    showModal = (id) => {
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        this.setState({
            visible: true,
        });
        let params = {
            access_token: token,
            id: id
        }
        this.setState({ id: id })
        subapi.versionDetails(params).then(res => {
            this.setState({ editorialContent: res.content })
        })
    };
    onClose = () => {
        this.setState({
          visible: false,
        });
       // window.location.reload();
       //window.history.go(0)
      };
      //灰度发布
      grayscale=(id)=>{
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
          let params={
            access_token:token,
            id:id
          }
          subapi.grayscaleRelease(params).then(res=>{
              if(res.code === 0){
                message.success('灰度发布成功');
               setTimeout(()=>{
                window.location.reload();
               },500)
              }else{
                message.error('灰度发布失败');
              }
          })
      }
      //设为当前版本
      currents=(id)=>{
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        let params={
            access_token:token,
            id:id
          }
          subapi.currentVersion(params).then(res=>{
              if(res.code === 0){
                message.success('设为当前版本成功');
               setTimeout(()=>{
                window.location.reload();
               },500)
              }else{
                message.error('设为当前版本失败');
              }
          })
      }
      //正式发布
      releaseVersion=(id)=>{
        let token = sessionStorage.getItem('access_token'); //获取鉴权token
        let params={
            access_token:token,
            id:id
          }
          subapi.currentVersion(params).then(res=>{
              if(res.code === 0){
                message.success('正式发布成功');
               setTimeout(()=>{
                window.location.reload();
               },500)
              }else{
                message.error('正式发布失败');
              }
          })
      }
    //   afterVisibleChange=(value)=>{
    //       console.log(value,"除非啦啦啦啦啦啦啦啦啦啦啦啦啦啦啦")
    //       if(value){
    //           this.setState({grayScaleRange:true})
    //       }else{
    //         this.setState({grayScaleRange:false})
    //       }
    //   }
    operations = (list) => {
        if (list.grayScale === '否' && list.state === '待发布') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定正式发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.releaseVersion(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>正式发布</a>
                    </Popconfirm>
                </span>
            )
        } else if (list.grayScale === '是' && list.state === '待发布') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定灰度发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.grayscale(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>灰度发布</a>
                </Popconfirm>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定正式发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.releaseVersion(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>正式发布</a>
                    </Popconfirm>
                </span>
            )
        } else if ((list.grayScale === '否' || list.grayScale === '是') && list.state === '灰度发布') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定正式发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.releaseVersion(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>正式发布</a>
                    </Popconfirm>
                </span>
            )
        } else if (list.state === '当前版本' && list.grayScale === '否') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                </span>
            )
        } else if (list.state === '当前版本' && list.grayScale === '是') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                    {/* <Divider type="vertical" />
                    <Popconfirm
                    title="确定灰度发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.grayscale(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>灰度发布</a>
                    </Popconfirm> */}
                    {/* <Divider type="vertical" />
                    <Popconfirm
                    title="确定正式发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.releaseVersion(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>正式发布</a>
                    </Popconfirm> */}
                </span>
            )
        } else if (list.grayScale === '是' && list.state === '历史版本') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定设为当前版本吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                        this.currents(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>设为当前版本</a>
                    </Popconfirm>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定灰度发布吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.grayscale(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>灰度发布</a>
                </Popconfirm>
                </span>
            )
        } else if (list.grayScale === '否' && list.state === '历史版本') {
            return (
                <span>
                    <a style={{ fontSize: '12px' }} onClick={() => this.props.examine(list.id)}>查看</a>
                    <Divider type="vertical" />
                    <a style={{ fontSize: '12px' }} onClick={() => this.showModal(list.id)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm
                    title="确定设为当前版本吗？"
                    okText="确定"
                    cancelText="取消"
                    onConfirm={() => {
                    this.currents(list.id)
                    }}>
                    <a style={{ fontSize: '12px' }}>设为当前版本</a>
                    </Popconfirm>
                </span>
            )
        }
    }
    render() {
       
        //console.log(this.props)
        //console.log(this.state.editorialContent)
        let data ="";
        if(this.props.dataList){
             data = this.props.dataList.map((item, index) => {
                let category = '';
                if (item.app === 'cgj' && item.type == '1') {
                    category = '彩管家Android'
                } else if (item.app === 'cgj' && item.type == '2') {
                    category = '彩管家ios'
                } else if (item.app === 'czy' && item.type == '1') {
                    category = '彩之云Android'
                } else if (item.app === 'czy' && item.type == '2') {
                    category = '彩之云ios'
                }else if (item.app === 'wyt' && item.type == '1') {
                    category = '物业通Android'
                }else if (item.app === 'wyt' && item.type == '2') {
                    category = '物业通ios'
                }
                let platform = '';
                if (item.app === 'cgj') {
                    platform = '彩管家平台'
                } else if (item.app === 'czy') {
                    platform = '彩之云平台'
                }else if (item.app === 'wyt') {
                    platform = '物业通平台'
                }
                let state = '';
                if (item.state === 0) {
                    state = '待发布'
                } else if (item.state === 1) {
                    state = '灰度发布'
                } else if (item.state === 2) {
                    state = '当前版本'
                } else if (item.state === 3) {
                    state = '历史版本'
                }
                let scale_content = item.scale_content;
                if (scale_content) {
                    scale_content = '是'
                } else {
                    scale_content = '否'
                }
                return {
                    key: index,
                    id: item.id,
                    version: item.version,
                    category: category,
                    platform: platform,
                    func: item.func,
                    min_version: item.min_version,
                    publish_at: item.publish_at,
                    create_at: item.create_at,
                    grayScale: scale_content,
                    state: state
                }
            })
        }
      
        const columns = [
            {
                title: 'id',
                dataIndex: 'id',
                key: 'id',
                fixed: 'left',
                width: 100
            },
            {
                title: '版本号',
                width: 100,
                dataIndex: 'version',
                key: 'version',
            },
            {
                title: 'App类别',
                dataIndex: 'category',
                key: 'category',
                width: 120
            },
            {
                title: '发布平台',
                dataIndex: 'platform',
                key: 'platform',
                width: 120
            },
            {
                title: '发版内容',
                dataIndex: 'func',
                key: 'func',

            },
            {
                title: '支持最低版本号',
                dataIndex: 'min_version',
                key: 'min_version',

            },
            {
                title: '发版时间',
                dataIndex: 'publish_at',
                key: 'publish_at',
                width: 120

            },
            {
                title: '创建时间',
                dataIndex: 'create_at',
                key: 'create_at',
                width: 120
            },
            {
                title: '是否支持灰度发布',
                dataIndex: 'grayScale',
                key: 'grayScale',

            },
            {
                title: '状态',
                dataIndex: 'state',
                key: 'state',
                width: 190

            },
            {
                title: '操作',
                key: 'operation',
                fixed: 'right',

                render: (text, record) =>
                    this.operations(record)

            },
        ]
        const options = {
            current: this.props.options.page,
            defaultPageSize: this.props.options.page_size,
            pageSizeOptions: this.props.options.pageSizeOptions,
            total: this.props.total.total,
            showTotal: total => `共 ${total} 条记录`,
            showSizeChanger: true,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
                //console.log(page,pageSize)
                //console.log('页码改变的回调，参数是改变后的页码: ' + page + ',及每页条数: ' + pageSize);
                this.props.options.pageSizeChange(page, pageSize);
                //this.props.managementList({ current: page, pageSize: pageSize });
                //this.props.managementList(page, pageSize);
                this.props.pagingList({ page: page, page_size: pageSize })
            },
            onShowSizeChange: (current, size) => {
                // console.log('pageSize 变化的回调: ' + current + ',及每页条数: ' + size);
                this.props.options.pageSizeChange(1, size);
                //this.props.managementList({ current: 1, pageSize: size });
                //this.props.managementList(1, size)
                this.props.pagingList({ page: 1, page_size: size });
            },
        };

        return (
            <div id="mapDiv">
                <Table columns={columns} dataSource={data} scroll={{ x: 1500 }}
                    pagination={false}
                />
                <Pagination
                    style={{
                        float: 'right',
                        marginTop: '2rem',
                    }}
                    {...options}
                />
                <Drawer
                    title="编辑版本"
                    placement="right"
                    width='60%'
                    onClose={this.onClose}
                    visible={this.state.visible}
                >
                    <EditVersion
                        editorialContent={this.state.editorialContent}
                        id={this.state.id}
                    ></EditVersion>
                </Drawer>
            </div>
        );
    }
}
